var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1623_6025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0799 51.02C43.4964 51.02 51.1299 43.3865 51.1299 33.97C51.1299 24.5535 43.4964 16.92 34.0799 16.92C24.6635 16.92 17.0299 24.5535 17.0299 33.97C17.0299 43.3865 24.6635 51.02 34.0799 51.02Z",
    fill: "url(#paint0_linear_1623_6025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 47.03C39.4164 47.03 47.0499 39.3964 47.0499 29.98C47.0499 20.5635 39.4164 12.93 30 12.93C20.5835 12.93 12.95 20.5635 12.95 29.98C12.95 39.3964 20.5835 47.03 30 47.03Z",
    fill: "#043263"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1499 15.03L22.1399 45.15C30.4999 49.49 40.7999 46.22 45.1299 37.86C49.4599 29.5 46.2999 19.47 38.1499 15.03Z",
    fill: "url(#paint1_linear_1623_6025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.97 33.11C27.9064 32.5423 27.8763 31.9713 27.88 31.4C27.88 29.59 29 28.54 30.4 27.78C31.8 27.02 32.31 26.51 32.31 25.35C32.31 24.39 31.5 23.72 30.07 23.72C28.4 23.72 26.8 24.75 25.92 25.87L23.73 23.53C25.09 21.96 27.28 20.67 30.47 20.67C34.1 20.67 36.07 22.51 36.07 25.04C36.07 27.25 34.81 28.32 33.26 29.16C31.09 30.28 31.12 30.76 31.12 33.11H27.97ZM27.51 36.51C27.51 35.51 28.21 34.71 29.52 34.71C30.83 34.71 31.58 35.51 31.58 36.51C31.58 37.51 30.86 38.31 29.52 38.31C28.18 38.31 27.51 37.48 27.51 36.51Z",
    fill: "#2DCCCD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1623_6025",
    x1: 24.5299,
    y1: 16.01,
    x2: 42.8219,
    y2: 50.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#192647",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192647",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1623_6025",
    x1: 47.1859,
    y1: 31.046,
    x2: 22.1399,
    y2: 31.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#072146",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#072146",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1623_6025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpDark);
export default __webpack_public_path__ + "static/media/help-dark.557c7fc0e43965fc74f7f5190146790a.svg";
export { ForwardRef as ReactComponent };